import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "rounded-lg border border-ewhite-200 bg-white" };
const _hoisted_2 = { class: "flex flex-wrap items-center justify-between gap-3 border-b border-ewhite-100 p-4" };
const _hoisted_3 = { class: "text-base font-semibold text-eblack-900" };
const _hoisted_4 = { class: "mt-1 text-sm text-eblack-500" };
const _hoisted_5 = ["disabled"];
const _hoisted_6 = {
    key: 0,
    class: "m-4 flex flex-wrap items-center justify-between gap-3 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700",
    "data-test": "feature-flags-error"
};
const _hoisted_7 = {
    key: 1,
    class: "p-4 text-sm text-eblack-500",
    "data-test": "feature-flags-loading"
};
const _hoisted_8 = {
    key: 2,
    class: "divide-y divide-ewhite-100",
    "data-test": "feature-flags-panel"
};
const _hoisted_9 = ["data-test"];
const _hoisted_10 = { class: "grid gap-4 lg:grid-cols-[minmax(0,1fr)_220px]" };
const _hoisted_11 = { class: "min-w-0" };
const _hoisted_12 = { class: "font-mono text-sm font-semibold text-eblack-900" };
const _hoisted_13 = { class: "mt-1 text-sm text-eblack-500" };
const _hoisted_14 = ["data-test", "onClick"];
const _hoisted_15 = { class: "flex items-center justify-between gap-3 lg:justify-end" };
const _hoisted_16 = { class: "inline-flex cursor-pointer items-center gap-2" };
const _hoisted_17 = { class: "sr-only" };
const _hoisted_18 = ["checked", "disabled", "data-test", "onChange"];
const _hoisted_19 = { class: "relative h-6 w-11 rounded-full bg-ewhite-300 transition-colors peer-checked:bg-eorange-500 peer-disabled:opacity-60" };
const _hoisted_20 = ["data-test"];
const _hoisted_21 = { class: "text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_22 = {
    key: 0,
    class: "mt-2 text-sm text-eblack-500"
};
const _hoisted_23 = {
    key: 1,
    class: "mt-2 grid gap-2"
};
const _hoisted_24 = { class: "font-mono text-eblack-700" };
const _hoisted_25 = { class: "inline-flex cursor-pointer items-center gap-2" };
const _hoisted_26 = ["checked", "disabled", "data-test", "onChange"];
const _hoisted_27 = { class: "relative h-5 w-9 rounded-full bg-ewhite-300 transition-colors peer-checked:bg-eorange-500 peer-disabled:opacity-60" };
const _hoisted_28 = ["data-test", "onSubmit"];
const _hoisted_29 = { class: "flex flex-col gap-1 text-xs font-medium text-eblack-700" };
const _hoisted_30 = ["onUpdate:modelValue", "placeholder", "data-test"];
const _hoisted_31 = { class: "flex items-center gap-2 pb-2 text-sm text-eblack-700" };
const _hoisted_32 = ["onUpdate:modelValue"];
const _hoisted_33 = ["disabled", "data-test"];
const _hoisted_34 = {
    key: 0,
    class: "p-4 text-sm text-eblack-500"
};
import { onMounted, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useToast } from "vue-toastification";
import { featureFlagRepository, } from "../repositories/feature-flag.repository";
import { useFeatureFlagStore } from "../stores";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FeatureFlagAdminPanel',
    setup(__props) {
        const { t } = useI18n();
        const toast = useToast();
        const featureFlagStore = useFeatureFlagStore();
        const flags = ref([]);
        const isLoading = ref(false);
        const error = ref(null);
        const savingFlagId = ref(null);
        const savingOverrideKey = ref(null);
        const expandedOverrides = ref(new Set());
        const newOverrideForms = reactive({});
        onMounted(() => {
            void loadFlags();
        });
        async function loadFlags() {
            isLoading.value = true;
            error.value = null;
            try {
                flags.value = await featureFlagRepository.getAdminFlags();
                for (const flag of flags.value) {
                    if (!newOverrideForms[flag.id]) {
                        newOverrideForms[flag.id] = { organizationId: "", enabled: true };
                    }
                }
            }
            catch (err) {
                error.value =
                    err instanceof Error
                        ? err.message
                        : t("settings.feature_flags.load_failed");
            }
            finally {
                isLoading.value = false;
            }
        }
        async function updateGlobalFlag(flag, event) {
            const target = event.target;
            const nextEnabled = target?.checked === true;
            const previousEnabled = flag.globalValue;
            flag.globalValue = nextEnabled;
            savingFlagId.value = flag.id;
            try {
                await featureFlagStore.setGlobalValue(flag.id, nextEnabled);
                toast.success(t("settings.feature_flags.saved"));
            }
            catch (err) {
                flag.globalValue = previousEnabled;
                if (target)
                    target.checked = previousEnabled;
                toast.error(err instanceof Error ? err.message : t("settings.feature_flags.save_failed"));
            }
            finally {
                savingFlagId.value = null;
            }
        }
        function overrideKey(flagId, organizationId) {
            return `${flagId}:${organizationId}`;
        }
        function isOverridesExpanded(flagId) {
            return expandedOverrides.value.has(flagId);
        }
        function toggleOverridesExpanded(flagId) {
            if (expandedOverrides.value.has(flagId)) {
                expandedOverrides.value.delete(flagId);
            }
            else {
                expandedOverrides.value.add(flagId);
            }
        }
        async function saveOverride(flag, organizationId, enabled) {
            const key = overrideKey(flag.id, organizationId);
            const existing = flag.organizationOverrides.find((item) => item.organizationId === organizationId);
            const previousEnabled = existing?.enabled ?? !enabled;
            if (existing)
                existing.enabled = enabled;
            savingOverrideKey.value = key;
            try {
                await featureFlagStore.setOrgOverride(flag.id, organizationId, enabled);
                toast.success(t("settings.feature_flags.override_saved"));
            }
            catch (err) {
                if (existing)
                    existing.enabled = previousEnabled;
                toast.error(err instanceof Error
                    ? err.message
                    : t("settings.feature_flags.override_save_failed"));
            }
            finally {
                savingOverrideKey.value = null;
            }
        }
        async function addOverride(flag) {
            const form = newOverrideForms[flag.id];
            const organizationId = Number(form?.organizationId);
            if (!organizationId || organizationId <= 0)
                return;
            const key = overrideKey(flag.id, organizationId);
            savingOverrideKey.value = key;
            try {
                await featureFlagStore.setOrgOverride(flag.id, organizationId, form.enabled);
                const existing = flag.organizationOverrides.find((item) => item.organizationId === organizationId);
                if (existing) {
                    existing.enabled = form.enabled;
                }
                else {
                    flag.organizationOverrides.push({ organizationId, enabled: form.enabled });
                }
                newOverrideForms[flag.id] = { organizationId: "", enabled: true };
                toast.success(t("settings.feature_flags.override_saved"));
            }
            catch (err) {
                toast.error(err instanceof Error
                    ? err.message
                    : t("settings.feature_flags.override_save_failed"));
            }
            finally {
                savingOverrideKey.value = null;
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, [
                        _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(t)("settings.feature_flags.title")), 1),
                        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("settings.feature_flags.subtitle")), 1)
                    ]),
                    _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex h-9 items-center rounded-lg border border-ewhite-200 px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50 disabled:opacity-60",
                        "data-test": "feature-flags-refresh",
                        disabled: isLoading.value,
                        onClick: loadFlags
                    }, _toDisplayString(_unref(t)("settings.feature_flags.refresh")), 9, _hoisted_5)
                ]),
                (error.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("span", null, _toDisplayString(error.value), 1),
                        _createElementVNode("button", {
                            type: "button",
                            class: "rounded-md border border-red-200 px-2.5 py-1 font-medium hover:bg-red-100",
                            onClick: loadFlags
                        }, _toDisplayString(_unref(t)("settings.feature_flags.retry")), 1)
                    ]))
                    : _createCommentVNode("", true),
                (isLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(t)("settings.feature_flags.loading")), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flags.value, (flag) => {
                            return (_openBlock(), _createElementBlock("article", {
                                key: flag.id,
                                class: "p-4",
                                "data-test": `feature-flag-row-${flag.key}`
                            }, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("p", _hoisted_12, _toDisplayString(flag.key), 1),
                                        _createElementVNode("p", _hoisted_13, _toDisplayString(flag.description || _unref(t)("settings.feature_flags.no_description")), 1),
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "mt-2 text-xs font-semibold text-eorange-600 hover:text-eorange-700",
                                            "data-test": `feature-flag-toggle-overrides-${flag.key}`,
                                            onClick: ($event) => (toggleOverridesExpanded(flag.id))
                                        }, _toDisplayString(isOverridesExpanded(flag.id)
                                            ? _unref(t)("settings.feature_flags.hide_overrides")
                                            : _unref(t)("settings.feature_flags.override_count", {
                                                count: flag.organizationOverrides.length,
                                            })), 9, _hoisted_14)
                                    ]),
                                    _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["rounded-full px-2 py-0.5 text-xs font-semibold",
                                                flag.globalValue
                                                    ? 'bg-egreen-50 text-egreen-700'
                                                    : 'bg-ewhite-100 text-eblack-500'
                                            ])
                                        }, _toDisplayString(flag.globalValue
                                            ? _unref(t)("settings.feature_flags.enabled")
                                            : _unref(t)("settings.feature_flags.disabled")), 3),
                                        _createElementVNode("label", _hoisted_16, [
                                            _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)("settings.feature_flags.toggle", { key: flag.key })), 1),
                                            _createElementVNode("input", {
                                                type: "checkbox",
                                                class: "peer sr-only",
                                                checked: flag.globalValue,
                                                disabled: savingFlagId.value === flag.id,
                                                "data-test": `feature-flag-toggle-${flag.key}`,
                                                onChange: ($event) => (updateGlobalFlag(flag, $event))
                                            }, null, 40, _hoisted_18),
                                            _createElementVNode("span", _hoisted_19, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(["absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-white transition-transform", flag.globalValue ? 'translate-x-5' : 'translate-x-0'])
                                                }, null, 2)
                                            ])
                                        ])
                                    ])
                                ]),
                                (isOverridesExpanded(flag.id))
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "mt-3 rounded-lg border border-ewhite-200 bg-ewhite-50 p-3",
                                        "data-test": `feature-flag-overrides-${flag.key}`
                                    }, [
                                        _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(t)("settings.feature_flags.overrides_title")), 1),
                                        (flag.organizationOverrides.length === 0)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_unref(t)("settings.feature_flags.overrides_empty")), 1))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flag.organizationOverrides, (override) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: override.organizationId,
                                                        class: "flex items-center justify-between gap-3 rounded-md bg-white px-3 py-2 text-sm"
                                                    }, [
                                                        _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)("settings.feature_flags.org_id_column")) + " #" + _toDisplayString(override.organizationId), 1),
                                                        _createElementVNode("label", _hoisted_25, [
                                                            _createElementVNode("input", {
                                                                type: "checkbox",
                                                                class: "peer sr-only",
                                                                checked: override.enabled,
                                                                disabled: savingOverrideKey.value === overrideKey(flag.id, override.organizationId),
                                                                "data-test": `feature-flag-override-toggle-${flag.key}-${override.organizationId}`,
                                                                onChange: ($event) => (saveOverride(flag, override.organizationId, $event.target.checked))
                                                            }, null, 40, _hoisted_26),
                                                            _createElementVNode("span", _hoisted_27, [
                                                                _createElementVNode("span", {
                                                                    class: _normalizeClass(["absolute left-0.5 top-0.5 h-4 w-4 rounded-full bg-white transition-transform", override.enabled ? 'translate-x-4' : 'translate-x-0'])
                                                                }, null, 2)
                                                            ])
                                                        ])
                                                    ]));
                                                }), 128))
                                            ])),
                                        _createElementVNode("form", {
                                            class: "mt-3 flex flex-wrap items-end gap-2",
                                            "data-test": `feature-flag-override-form-${flag.key}`,
                                            onSubmit: _withModifiers(($event) => (addOverride(flag)), ["prevent"])
                                        }, [
                                            _createElementVNode("label", _hoisted_29, [
                                                _createTextVNode(_toDisplayString(_unref(t)("settings.feature_flags.override_org_label")) + " ", 1),
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": ($event) => ((newOverrideForms[flag.id].organizationId) = $event),
                                                    type: "number",
                                                    min: "1",
                                                    class: "h-9 w-32 rounded-md border border-ewhite-200 px-2 text-sm",
                                                    placeholder: _unref(t)('settings.feature_flags.override_org_placeholder'),
                                                    "data-test": `feature-flag-override-org-input-${flag.key}`
                                                }, null, 8, _hoisted_30), [
                                                    [_vModelText, newOverrideForms[flag.id].organizationId]
                                                ])
                                            ]),
                                            _createElementVNode("label", _hoisted_31, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": ($event) => ((newOverrideForms[flag.id].enabled) = $event),
                                                    type: "checkbox"
                                                }, null, 8, _hoisted_32), [
                                                    [_vModelCheckbox, newOverrideForms[flag.id].enabled]
                                                ]),
                                                _createTextVNode(" " + _toDisplayString(_unref(t)("settings.feature_flags.override_enabled_label")), 1)
                                            ]),
                                            _createElementVNode("button", {
                                                type: "submit",
                                                class: "h-9 rounded-lg border border-ewhite-200 bg-white px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50 disabled:opacity-60",
                                                disabled: !newOverrideForms[flag.id].organizationId,
                                                "data-test": `feature-flag-override-add-${flag.key}`
                                            }, _toDisplayString(_unref(t)("settings.feature_flags.add_override")), 9, _hoisted_33)
                                        ], 40, _hoisted_28)
                                    ], 8, _hoisted_20))
                                    : _createCommentVNode("", true)
                            ], 8, _hoisted_9));
                        }), 128)),
                        (flags.value.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_unref(t)("settings.feature_flags.empty")), 1))
                            : _createCommentVNode("", true)
                    ]))
            ]));
        };
    }
});
